import type { CSSProperties } from 'react'
import { COLORS, FONT, TAB_HEIGHT, SAFE_BOTTOM } from './tokens'

export type TabId = 'search' | 'publish' | 'location' | 'radio' | 'profile'

interface Tab { id: TabId; icon: string; label: string }

const TABS: Tab[] = [
  { id: 'search',   icon: '🔍', label: 'Поиск' },
  { id: 'publish',  icon: '➕', label: 'Поездка' },
  { id: 'location', icon: '🗺️', label: 'Карта' },
  { id: 'radio',    icon: '📻', label: 'Рация' },
  { id: 'profile',  icon: '👤', label: 'Профиль' },
]

interface Props { active: TabId; onChange: (tab: TabId) => void }

export function BottomTabs({ active, onChange }: Props) {
  const barStyle: CSSProperties = {
    position: 'fixed', bottom: 0, left: 0, right: 0,
    height: TAB_HEIGHT, paddingBottom: SAFE_BOTTOM,
    backgroundColor: COLORS.bgCard, borderTop: `1px solid ${COLORS.border}`,
    display: 'flex', alignItems: 'stretch', zIndex: 100,
    WebkitBackdropFilter: 'blur(12px)', backdropFilter: 'blur(12px)',
  }

  return (
    <nav style={barStyle}>
      {TABS.map((tab) => {
        const isActive = tab.id === active
        return (
          <button key={tab.id} style={{
            flex: 1, display: 'flex', flexDirection: 'column',
            alignItems: 'center', justifyContent: 'center', gap: 2,
            background: 'none', border: 'none', cursor: 'pointer', padding: '6px 0',
            color: isActive ? COLORS.accent : COLORS.textDisabled,
            transition: 'color 0.15s', WebkitTapHighlightColor: 'transparent', minHeight: 44,
          }} onClick={() => onChange(tab.id)} aria-label={tab.label}>
            <span style={{ fontSize: 22, lineHeight: 1 }}>{tab.icon}</span>
            <span style={{ fontSize: FONT.xs, lineHeight: 1.2, fontWeight: isActive ? 600 : 400 }}>
              {tab.label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
